import React, { Component, useEffect, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";

import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
import SyncHistoryWeb from "./syncHistoryWeb";
import SyncHistoryMobile from "./syncHistoryMobile";
const SyncHistoryComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("DigitalCard");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Digital Card",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <SyncHistoryWeb></SyncHistoryWeb>
      </BrowserView>
      <MobileView>
        <SyncHistoryMobile></SyncHistoryMobile>
      </MobileView>
    </>
  );
};

export default SyncHistoryComponent;
